module.exports = __webpack_public_path__ + "static/atherton-265f3a178b127a79f2ea1e989c823115.jpg";